function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("metadata", {
  id: "metadata8"
}, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
  rdfbout: ""
}, /*#__PURE__*/React.createElement("dcformat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dctype", {
  rdfresource: "http://purl.org/dc/dcmitype/StillImage"
}))));

var _ref3 = /*#__PURE__*/React.createElement("defs", {
  id: "defs6"
});

var SvgSamsung = function SvgSamsung(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsdc: "http://purl.org/dc/elements/1.1/",
    xmlnscc: "http://creativecommons.org/ns#",
    xmlnsrdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnssvg: "http://www.w3.org/2000/svg",
    viewBox: "30 104 195 50",
    height: 50,
    width: 175,
    xmlSpace: "preserve",
    id: "svg2",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,258.66667)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.1)",
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 2.59766,1933.23 H 1930.16 V 5.66797 H 2.59766 V 1933.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 1043.86,977.805 c 0,0 -15.58,9.644 -25.23,13.371 0,0 -29.837,13.824 -35.767,20.414 0,0 -11.617,10.95 -4.816,23.68 0,0 2.848,8.33 15.137,8.33 0,0 15.996,-0.88 15.996,-14.03 v -18.55 h 57.35 l -0.11,27.32 c 0,0 4.41,44.75 -67.541,46.71 0,0 -56.582,3.72 -72.813,-26.76 0,0 -6.367,-6.79 -6.367,-30.47 v -17.12 c 0,0 -0.652,-19.735 9.434,-32.45 0,0 5.703,-8.332 19.746,-17.547 0,0 28.508,-15.351 45.613,-24.137 0,0 17.278,-9.855 14.998,-25.543 0,0 -1.4,-16.105 -18.08,-15.449 0,0 -15.254,0.692 -15.254,16.485 v 18.539 h -61.097 v -26.934 c 0,0 -1.719,-51.512 76.804,-51.512 0,0 75.007,-1.527 78.517,52.868 v 21.914 c 0,0 2.64,33.336 -26.52,50.871"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 750.309,1078.64 -19.2,-120.316 h -4.492 l -18.344,119.246 h -95.781 l -4.793,-217.882 h 56.711 l 0.676,164.162 h 4.461 l 30.058,-164.131 h 59.661 l 29.695,164.071 h 3.949 l 1.367,-164.102 h 57.004 l -6.129,218.952 h -94.843"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 412.73,1077.74 374.996,859.934 h 61.047 l 22.348,168.876 h 5.023 l 22.344,-168.876 h 61.039 L 509.074,1077.74 H 412.73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 1693.75,980.809 v -32.137 h 15.66 V 914.18 c 0,-16.852 -14.41,-17.164 -14.41,-17.164 -17.53,0 -16.86,16.019 -16.86,16.019 v 119.305 c 0,12.29 15.54,12.95 15.54,12.95 14.93,0 15.04,-14.66 15.04,-14.66 v -18.15 h 57.48 c 1.87,35.41 -5.18,43.98 -5.18,43.98 -14.26,32.02 -68.2,30.27 -68.2,30.27 -82.89,0 -73.7,-63.6 -73.7,-63.6 V 907.777 c 1.78,-59.648 83.45,-53.597 84.84,-53.523 36.34,4.023 47.31,15.562 47.31,15.562 10.1,7.5 12.7,17.879 12.7,17.879 2.88,6.055 3.61,25.34 3.61,25.34 v 67.774 h -73.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 1503.22,945.355 h -2.49 l -58.35,133.235 h -69.77 V 859.648 h 56.79 l -3.41,133.219 h 2.54 l 60.43,-133.219 h 67.68 v 218.962 h -57.51 l 4.09,-133.255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 1233.94,914.207 c 0,0 0.83,-17.973 -15.83,-17.973 0,0 -17.53,-0.937 -17.53,17.528 l -0.18,164.698 h -62.3 V 915.07 c 0,0 -6.39,-61.843 80.88,-61.843 0,0 75.84,-0.899 75.84,59.007 v 166.216 h -60.88 V 914.207"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 293.953,977.813 c 0,0 -15.566,9.636 -25.219,13.363 0,0 -29.824,13.814 -35.738,20.414 0,0 -11.629,10.97 -4.82,23.67 0,0 2.84,8.33 15.117,8.33 0,0 16.012,-0.87 16.012,-14.02 v -18.55 h 57.359 l -0.113,27.33 c 0,0 4.383,44.74 -67.543,46.7 0,0 -5.418,0.35 -13.367,-0.05 0,0 -43.571,-2.34 -59.149,-26.24 -0.086,-0.17 -0.215,-0.31 -0.304,-0.47 0,0 -6.36,-6.78 -6.36,-30.47 v -17.12 c 0,0 -0.656,-19.731 9.438,-32.45 0,0 5.695,-8.332 19.738,-17.547 0,0 28.496,-15.348 45.609,-24.125 0,0 17.289,-9.859 15.004,-25.555 0,0 -1.406,-16.105 -18.074,-15.449 0,0 -15.254,0.692 -15.254,16.485 v 18.55 h -61.113 v -26.945 c 0,0 -1.707,-51.512 76.801,-51.512 0,0 75,-1.527 78.523,52.868 v 21.91 c 0,0 2.629,33.34 -26.547,50.883"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSamsung, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/samsung.eade3dc1.svg";
export { ForwardRef as ReactComponent };